import React from "react";

export const Headline = ({ title, sub }) => (
  <header className="results-headline">
    <h3 className="results-headline__title">{title}</h3>
    {sub ? <p className="results-headline__sub">{sub}</p> : null}
  </header>
);
